/*
 * Update Notifications
 */

export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION"
export const UPDATE_NOTIFICATION_SUCCESS = "UPDATE_NOTIFICATION_SUCCESS"
export const UPDATE_NOTIFICATION_ERROR = "UPDATE_NOTIFICATION_ERROR"
